import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useState, useEffect } from 'react';
import MiCuestionarioTab from '../pages/cuestionarios/MiCuestionarioTab';
import { useProfile } from '../hooks/useProfile';
import CustomDatePicker from './users/steps/CustomDatePicker';

const ViewProfileLayer = () => {
    const { getMiPerfil, updateMiPerfil, cambiarPassword } = useProfile();
    const [profile, setProfile] = useState(null);
    const [loading, setLoading] = useState(true);

    const [formData, setFormData] = useState({
        nombres: '',
        apellido_paterno: '',
        apellido_materno: '',
        telefono: '',
        fecha_nacimiento: '',
        estado_civil: '',
        curp: '',
        rfc: '',
    });

    const [passwordData, setPasswordData] = useState({
        old_password: '',
        new_password: '',
        confirm_password: ''
    });

    const [passwordVisible, setPasswordVisible] = useState(false);
    const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
    const [oldPasswordVisible, setOldPasswordVisible] = useState(false);

    const [msgEdit, setMsgEdit] = useState({ type: '', text: '' });
    const [msgPass, setMsgPass] = useState({ type: '', text: '' });

    const fetchProfile = async () => {
        try {
            const res = await getMiPerfil();
            setProfile(res.data);
            setFormData({
                nombres: res.data.nombres || '',
                apellido_paterno: res.data.apellido_paterno || '',
                apellido_materno: res.data.apellido_materno || '',
                telefono: res.data.telefono || '',
                fecha_nacimiento: res.data.fecha_nacimiento || '',
                estado_civil: res.data.estado_civil || '',
                curp: res.data.curp || '',
                rfc: res.data.rfc || '',
            });
        } catch (error) {
            console.error("Error fetching profile", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchProfile();
    }, []);

    const togglePasswordVisibility = () => setPasswordVisible(!passwordVisible);
    const toggleConfirmPasswordVisibility = () => setConfirmPasswordVisible(!confirmPasswordVisible);
    const toggleOldPasswordVisibility = () => setOldPasswordVisible(!oldPasswordVisible);

    const handleFormChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handlePassChange = (e) => {
        setPasswordData({ ...passwordData, [e.target.name]: e.target.value });
    };

    const handleUpdateProfile = async (e) => {
        e.preventDefault();
        setMsgEdit({ type: '', text: '' });
        try {
            const res = await updateMiPerfil(formData);
            setProfile(res.data);
            setMsgEdit({ type: 'success', text: 'Perfil actualizado correctamente.' });
        } catch (error) {
            setMsgEdit({ type: 'error', text: 'Error al actualizar perfil.' });
        }
    };

    const handleChangePassword = async (e) => {
        e.preventDefault();
        setMsgPass({ type: '', text: '' });
        if (passwordData.new_password !== passwordData.confirm_password) {
            setMsgPass({ type: 'error', text: 'Las contraseñas nuevas no coinciden.' });
            return;
        }
        try {
            await cambiarPassword({
                old_password: passwordData.old_password,
                new_password: passwordData.new_password
            });
            setMsgPass({ type: 'success', text: 'Contraseña actualizada correctamente.' });
            setPasswordData({ old_password: '', new_password: '', confirm_password: '' });
        } catch (error) {
            setMsgPass({ type: 'error', text: error.response?.data?.error || 'Error al cambiar la contraseña.' });
        }
    };

    if (loading) return <div className="text-center py-5">Cargando perfil...</div>;
    if (!profile) return <div className="text-center py-5 text-danger">No se pudo cargar el perfil.</div>;

    return (
        <div className="row gy-4">
            <div className="col-lg-4">
                <div className="user-grid-card position-relative border radius-16 overflow-hidden bg-base h-100">
                    <img
                        src="assets/images/user-grid/user-grid-bg1.png"
                        alt=""
                        className="w-100 object-fit-cover"
                    />
                    <div className="pb-24 ms-16 mb-24 me-16  mt--100">
                        <div className="text-center border border-top-0 border-start-0 border-end-0">
                            <div className="border br-white border-width-2-px w-200-px h-200-px rounded-circle object-fit-cover d-flex justify-content-center align-items-center bg-primary-50 text-primary mx-auto" style={{fontSize: "5rem"}}>
                                {profile.nombres ? profile.nombres.charAt(0).toUpperCase() : 'U'}
                            </div>
                            <h6 className="mb-0 mt-16">{profile.nombre_completo}</h6>
                            <span className="text-secondary-light mb-16">{profile.email}</span>
                        </div>
                        <div className="mt-24">
                            <h6 className="text-xl mb-16">Información Personal</h6>
                            <ul>
                                <li className="d-flex align-items-center gap-1 mb-12">
                                    <span className="w-30 text-md fw-semibold text-primary-light">Usuario</span>
                                    <span className="w-70 text-secondary-light fw-medium">: {profile.username}</span>
                                </li>
                                <li className="d-flex align-items-center gap-1 mb-12">
                                    <span className="w-30 text-md fw-semibold text-primary-light">Rol</span>
                                    <span className="w-70 text-secondary-light fw-medium">: {profile.rol_display}</span>
                                </li>
                                <li className="d-flex align-items-center gap-1 mb-12">
                                    <span className="w-30 text-md fw-semibold text-primary-light">Teléfono</span>
                                    <span className="w-70 text-secondary-light fw-medium">: {profile.telefono || 'N/A'}</span>
                                </li>
                                <li className="d-flex align-items-center gap-1 mb-12">
                                    <span className="w-30 text-md fw-semibold text-primary-light">Plantel</span>
                                    <span className="w-70 text-secondary-light fw-medium">: {profile.plantel_nombre || 'N/A'}</span>
                                </li>
                                <li className="d-flex align-items-center gap-1 mb-12">
                                    <span className="w-30 text-md fw-semibold text-primary-light">Escuela</span>
                                    <span className="w-70 text-secondary-light fw-medium">: {profile.escuela_nombre || 'N/A'}</span>
                                </li>
                                <li className="d-flex align-items-center gap-1 mb-12">
                                    <span className="w-30 text-md fw-semibold text-primary-light">CURP</span>
                                    <span className="w-70 text-secondary-light fw-medium">: {profile.curp || 'N/A'}</span>
                                </li>
                                <li className="d-flex align-items-center gap-1 mb-12">
                                    <span className="w-30 text-md fw-semibold text-primary-light">RFC</span>
                                    <span className="w-70 text-secondary-light fw-medium">: {profile.rfc || 'N/A'}</span>
                                </li>
                                <li className="d-flex align-items-center gap-1">
                                    <span className="w-30 text-md fw-semibold text-primary-light">Estado Civil</span>
                                    <span className="w-70 text-secondary-light fw-medium">: {profile.estado_civil_display || 'N/A'}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-lg-8">
                <div className="card h-100">
                    <div className="card-body p-24">
                        <ul className="nav border-gradient-tab nav-pills mb-20 d-inline-flex" id="pills-tab" role="tablist">
                            <li className="nav-item" role="presentation">
                                <button className="nav-link d-flex align-items-center px-24 active" id="pills-edit-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-edit-profile" type="button" role="tab">Editar Perfil</button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button className="nav-link d-flex align-items-center px-24" id="pills-change-passwork-tab" data-bs-toggle="pill" data-bs-target="#pills-change-passwork" type="button" role="tab">Cambiar Contraseña</button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button className="nav-link d-flex align-items-center px-24" id="pills-cuestionarios-tab" data-bs-toggle="pill" data-bs-target="#pills-cuestionarios" type="button" role="tab">Información Adicional</button>
                            </li>
                        </ul>
                        <div className="tab-content" id="pills-tabContent">
                            <div className="tab-pane fade show active" id="pills-edit-profile" role="tabpanel">
                                {msgEdit.text && <div className={`alert alert-${msgEdit.type === 'success' ? 'success' : 'danger'}`}>{msgEdit.text}</div>}
                                <form onSubmit={handleUpdateProfile}>
                                    <div className="row">
                                        <div className="col-sm-4 mb-20">
                                            <label className="form-label fw-semibold text-primary-light text-sm mb-8">Nombres <span className="text-danger-600">*</span></label>
                                            <input type="text" className="form-control radius-8" name="nombres" value={formData.nombres} onChange={handleFormChange} required />
                                        </div>
                                        <div className="col-sm-4 mb-20">
                                            <label className="form-label fw-semibold text-primary-light text-sm mb-8">Apellido Paterno <span className="text-danger-600">*</span></label>
                                            <input type="text" className="form-control radius-8" name="apellido_paterno" value={formData.apellido_paterno} onChange={handleFormChange} required />
                                        </div>
                                        <div className="col-sm-4 mb-20">
                                            <label className="form-label fw-semibold text-primary-light text-sm mb-8">Apellido Materno <span className="text-danger-600">*</span></label>
                                            <input type="text" className="form-control radius-8" name="apellido_materno" value={formData.apellido_materno} onChange={handleFormChange} required />
                                        </div>
                                        <div className="col-sm-6 mb-20">
                                            <label className="form-label fw-semibold text-primary-light text-sm mb-8">Correo Electrónico</label>
                                            <input type="email" className="form-control radius-8 bg-neutral-100" value={profile.email || ''} disabled />
                                        </div>
                                        <div className="col-sm-6 mb-20">
                                            <label className="form-label fw-semibold text-primary-light text-sm mb-8">Teléfono</label>
                                            <input type="text" className="form-control radius-8" name="telefono" value={formData.telefono} onChange={handleFormChange} />
                                        </div>
                                        <div className="col-sm-6 mb-20">
                                            <label className="form-label fw-semibold text-primary-light text-sm mb-8">Fecha de Nacimiento</label>
                                            <div style={{ marginTop: '-4px' }}>
                                                <CustomDatePicker
                                                    name="fecha_nacimiento"
                                                    value={formData.fecha_nacimiento}
                                                    onChange={(name, val) => handleFormChange({ target: { name, value: val } })}
                                                    label="Fecha"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-6 mb-20">
                                            <label className="form-label fw-semibold text-primary-light text-sm mb-8">Estado Civil</label>
                                            <select className="form-control radius-8 form-select" name="estado_civil" value={formData.estado_civil} onChange={handleFormChange}>
                                                <option value="">Selecciona...</option>
                                                <option value="SOLTERO">Soltero(a)</option>
                                                <option value="CASADO">Casado(a)</option>
                                                <option value="DIVORCIADO">Divorciado(a)</option>
                                                <option value="VIUDO">Viudo(a)</option>
                                            </select>
                                        </div>
                                        <div className="col-sm-6 mb-20">
                                            <label className="form-label fw-semibold text-primary-light text-sm mb-8">CURP</label>
                                            <input type="text" className="form-control radius-8 text-uppercase" name="curp" value={formData.curp} onChange={handleFormChange} placeholder="18 caracteres" maxLength={18} />
                                        </div>
                                        <div className="col-sm-6 mb-20">
                                            <label className="form-label fw-semibold text-primary-light text-sm mb-8">RFC</label>
                                            <input type="text" className="form-control radius-8 text-uppercase" name="rfc" value={formData.rfc} onChange={handleFormChange} placeholder="13 caracteres" maxLength={13} />
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-end gap-3 mt-24">
                                        <button type="submit" className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8">Guardar Cambios</button>
                                    </div>
                                </form>
                            </div>
                            <div className="tab-pane fade" id="pills-change-passwork" role="tabpanel">
                                {msgPass.text && <div className={`alert alert-${msgPass.type === 'success' ? 'success' : 'danger'}`}>{msgPass.text}</div>}
                                <form onSubmit={handleChangePassword}>
                                    <div className="mb-20">
                                        <label className="form-label fw-semibold text-primary-light text-sm mb-8">Contraseña Actual <span className="text-danger-600">*</span></label>
                                        <div className="position-relative">
                                            <input type={oldPasswordVisible ? "text" : "password"} className="form-control radius-8" name="old_password" placeholder="Contraseña actual" value={passwordData.old_password} onChange={handlePassChange} required />
                                            <span className={`toggle-password ${oldPasswordVisible ? "ri-eye-off-line" : "ri-eye-line"} cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light`} onClick={toggleOldPasswordVisibility}></span>
                                        </div>
                                    </div>
                                    <div className="mb-20">
                                        <label className="form-label fw-semibold text-primary-light text-sm mb-8">Nueva Contraseña <span className="text-danger-600">*</span></label>
                                        <div className="position-relative">
                                            <input type={passwordVisible ? "text" : "password"} className="form-control radius-8" name="new_password" placeholder="Nueva contraseña" value={passwordData.new_password} onChange={handlePassChange} required />
                                            <span className={`toggle-password ${passwordVisible ? "ri-eye-off-line" : "ri-eye-line"} cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light`} onClick={togglePasswordVisibility}></span>
                                        </div>
                                    </div>
                                    <div className="mb-20">
                                        <label className="form-label fw-semibold text-primary-light text-sm mb-8">Confirmar Contraseña <span className="text-danger-600">*</span></label>
                                        <div className="position-relative">
                                            <input type={confirmPasswordVisible ? "text" : "password"} className="form-control radius-8" name="confirm_password" placeholder="Confirmar contraseña" value={passwordData.confirm_password} onChange={handlePassChange} required />
                                            <span className={`toggle-password ${confirmPasswordVisible ? "ri-eye-off-line" : "ri-eye-line"} cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light`} onClick={toggleConfirmPasswordVisibility}></span>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-end gap-3 mt-24">
                                        <button type="submit" className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8">Actualizar Contraseña</button>
                                    </div>
                                </form>
                            </div>
                            <div className="tab-pane fade" id="pills-cuestionarios" role="tabpanel">
                                <MiCuestionarioTab />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ViewProfileLayer;